import { HEADER_HEIGHT, EDITOR_LEFT_TABBAR_WIDTH } from 'constants/style';
import styled, { css } from 'styled-components';

export const sidePadding = css`
  padding: 0 24px;
`;

export const appSidePadding = css`
  padding: 0 12px;
`;

export const paperPadding = css`
  padding-left: 32px;
  padding-right: 24px;
`;

export const headerHeight = css`
  height: ${`${HEADER_HEIGHT}px`};
`;

export const sideBarRootWidth = css`
  width: 80px;
`;

export const sideBarSubWidth = css`
  width: 280px;
`;

export const ellipsis = css`
  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const editorLeftTabBarWidth = css`
  width: ${`${EDITOR_LEFT_TABBAR_WIDTH}px`};
`;

export const sideBarIconFillPath = styled.path<{ isSelected: boolean }>`
  ${({ isSelected, theme: { sideBar } }) => ({
    fill: isSelected ? sideBar.accentTextColor : sideBar.textColor,
  })}
`;

export const sideBarIconStrokePath = styled.path<{ isSelected: boolean }>`
  ${({ isSelected, theme: { sideBar } }) => ({
    stroke: isSelected ? sideBar.accentTextColor : sideBar.textColor,
  })}
`;

export const EditorIcon = styled.button`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px !important;
  border: none !important;
  background-color: transparent !important;
  font-size: 20px;

  &:disabled {
    opacity: 0.4;
  }
`;

export const EditorIconLayout = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const FormSection = styled.div<{ maxWidth?: number }>`
  max-width: ${(props) => (props.maxWidth ? `${props.maxWidth}px` : 'initial')};
  width: 100%;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormSectionLine = styled.div`
  margin: 16px 0;
  border-top: 1px solid ${(props) => props.theme.global.borderColor};
`;

export const RightSideBarContent = styled.div`
  position: relative;
  padding: 20px;
`;

export const RightSideBarHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 40px;
  /* border-bottom: 1px solid ${(props) => props.theme.global.borderColor}; */
  h1 {
    font-size: 24px;
    font-weight: 600;
  }

  span {
  }
`;
